import { TotalLanguagesRowDto } from '@families-link/shared';
import { Typography } from '@mui/material';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';

const helper = createColumnHelper<TotalLanguagesRowDto & { createdAt: string; updatedAt: string }>();

export type TotalLanguagesColumnName = 'language' | 'engagements' | 'surveysSent' | 'surveysCompleted';

export function useTotalLanguagesTableColumns(
	totalLanguagesColumnsList: TotalLanguagesColumnName[]
): ColumnDef<TotalLanguagesRowDto>[] {
	const columns = useMemo<ColumnDef<TotalLanguagesRowDto>[]>(
		() =>
			totalLanguagesColumnsList.map((column) => {
				switch (column) {
					case 'language':
						return helper.accessor('language', {
							header: 'Language',
							enableSorting: true,
							cell: ({ getValue }) => <Typography>{getValue()}</Typography>,
						}) as ColumnDef<TotalLanguagesRowDto>;

					case 'engagements':
						return helper.accessor('engagements', {
							header: 'Engagements',
							enableSorting: true,
							cell: ({ getValue }) => <Typography>{getValue()}</Typography>,
						}) as ColumnDef<TotalLanguagesRowDto>;

					case 'surveysSent':
						return helper.accessor('surveysSent', {
							header: 'Surveys Sent',
							enableSorting: true,
							cell: ({ getValue }) => <Typography>{getValue()}</Typography>,
						}) as ColumnDef<TotalLanguagesRowDto>;

					case 'surveysCompleted':
						return helper.accessor('surveysCompleted', {
							header: 'Surveys Completed',
							enableSorting: true,
							size: 170,
							cell: ({ getValue }) => <Typography>{getValue()}</Typography>,
						}) as ColumnDef<TotalLanguagesRowDto>;
				}
			}),
		[totalLanguagesColumnsList]
	);

	return columns;
}
